import ResultMessage from './ResultMessage';
export default ResultMessage;
